import { keyframes } from '@emotion/react';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  100% {
    opacity: 0;
  }
`;
